import React, { useContext } from 'react';

import styled from '@emotion/styled';

import {
  ReasonToDeleteAccountDataType,
  ReasonToDeleteAccountInitialValues,
  ReasonToDeleteAccountSchema,
} from '../../../../models/dashboard/settings/reason-to-delete-account';
import { deleteAccountAction } from '../../../../redux/slices/deleteAccountSlice';
import { useAppDisPatch } from '../../../../redux/store';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import {
  CustomStackedPlainRadio,
  CustomStackedPlainRadioFieldGroup,
} from '../../../FormCom/CustomStackedPlainRadioField';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';
import { ModalContext } from '../../ModalContext';

const DeleteReasonForm = () => {
  const { sliderIndex, setSliderIndexPos } = React.useContext(
    TranslatingContainerContext,
  )!;
  const dispatch = useAppDisPatch();
  const modalContext = useContext(ModalContext);

  const onSubmit = (value: ReasonToDeleteAccountDataType) => {
    dispatch(deleteAccountAction.setDeleteReasonSlider(value));
    setSliderIndexPos(1);
  };

  return (
    <Container className={sliderIndex > 0 ? 'inactive' : ''}>
      <FormComponent
        initialValues={ReasonToDeleteAccountInitialValues}
        schema={ReasonToDeleteAccountSchema}
        onSubmit={onSubmit}
      >
        <CustomStackedPlainRadioFieldGroup
          name='reasonToDeleteAccount'
          label='Select a Reason'
          className='large'
        >
          <CustomStackedPlainRadio
            name='reasonToDeleteAccount'
            value='The platform is too expensive'
            className='hug'
          >
            The platform is too expensive
          </CustomStackedPlainRadio>
          <CustomStackedPlainRadio
            name='reasonToDeleteAccount'
            value='It does not meet our business needs'
            className='hug'
          >
            It does not meet our business needs
          </CustomStackedPlainRadio>
          <CustomStackedPlainRadio
            name='reasonToDeleteAccount'
            value='We found a better alternative'
            className='hug'
          >
            We found a better alternative
          </CustomStackedPlainRadio>
          <CustomStackedPlainRadio
            name='reasonToDeleteAccount'
            value='Our team rarely uses the platform'
            className='hug'
          >
            Our team rarely uses the platform
          </CustomStackedPlainRadio>
          <CustomStackedPlainRadio
            name='reasonToDeleteAccount'
            value='We have issues with your support team'
            className='hug'
          >
            We have issues with your support team
          </CustomStackedPlainRadio>
        </CustomStackedPlainRadioFieldGroup>

        <SubmitBtnArea>
          <FormSubmitButton
            className='clear'
            btnType='button'
            onClick={() => {
              modalContext?.setShowModal(false);
            }}
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton className='red'>Submit</FormSubmitButton>
        </SubmitBtnArea>
      </FormComponent>
    </Container>
  );
};

export default DeleteReasonForm;

const Container = styled.div`
  display: flex;

  &.inactive > * {
    display: none;
  }
`;

const SubmitBtnArea = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;
